import { StyleSheet, Dimensions, Platform } from "react-native";
import Colors from '../utilities/Color'

const win = Dimensions.get("window");
var paddingLeft, paddingRight, mybackgroundColor, myalignSelf
const width = win.width
const myPlatform = Platform.OS
if (width < 768) {
  paddingLeft = 15
  paddingRight = 15
  mybackgroundColor = "red"
} else if (768 < width && width < 880) {
  paddingLeft = 90
  paddingRight = 90
  mybackgroundColor = "green"
} else if (width > 880) {
  paddingLeft = 200
  paddingRight = 200
  mybackgroundColor = "pink"
}
if (myPlatform != "web") {
  myalignSelf = "auto"
} else {
  myalignSelf = "center"
}


if (myPlatform != "web" && width > 768) {
  myalignSelf = "center"
} else {
  myalignSelf = myalignSelf
}


const adjustablepaddingRight = 1090 > win.width ? 0 : 80;
const direction = 1090 > win.width ? "column" : "row";
const adjustableMaxWidth = 1090 > win.width ? 450 : 1200;
const adjustableAlignSelf = 1090 > win.width ? "center" : "";

var GlobalStyles = StyleSheet.create({
  // overall page containers
  adjustableBodyContainer: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingBottom: 30,
    // backgroundColor: mybackgroundColor
  },
  containerN: {
    flex: 1,
  },
  containerNmax: {
    flex: 1,
    width: "100%",
    maxWidth: 450,
    alignSelf: myalignSelf
  },
  containerLB: {
    flex: 1,
    backgroundColor: "#ecf9fd",
  },
  // Mid blue bg
  containerMB: {
    flex: 1,
    backgroundColor: Colors.MIDBLUE,
  },
  containerMBMax: {
    flex: 1,
    width: "100%",
    backgroundColor: Colors.MIDBLUE,
    maxWidth: 450,
    alignSelf: myalignSelf
  },
  containerW: {
    flex: 1,
    backgroundColor: Colors.WHITE,
  },

  containerWMax: {
    flex: 1,
    width: "100%",
    backgroundColor: Colors.WHITE,
    maxWidth: 450,
    alignSelf: myalignSelf
  },
  containerC: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  //body layouts
  bodyContainer: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 30,
  },
  bodyContainerFull: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 0,
    paddingRight: 0,
  },
  bodyContainerCards: {
    flex: 1,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
  bodyContainerT: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  bodyContainerI: {
    flex: 1,
    marginTop: 20,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 20,
  },
  // header layouts

  // header with keyline
  headerContainerKL: {
    height: 88,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 50,
    borderBottomColor: "#dddddd",
    borderBottomWidth: 1,
    borderLeftColor: "#dddddd",
    borderLeftWidth: 1,
  },
  headerContainerKLForLongText: {
    height: 99,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 50,
    borderBottomColor: "#dddddd",
    borderBottomWidth: 1,
    borderLeftColor: "#dddddd",
    borderLeftWidth: 1,
  },
  // header with white keyline
  headerContainerWKL: {
    height: 88,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 50,
    borderBottomColor: "#ffffff",
    borderBottomWidth: 1,
    borderLeftColor: "#ffffff",
    borderLeftWidth: 1,
  },
  // header with keyline fro spend insights screen
  headerContainerKLSpend: {
    height: 140,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 50,
    borderBottomColor: "#dddddd",
    borderBottomWidth: 1,
    borderLeftColor: "#dddddd",
    borderLeftWidth: 1,
  },
  // header with keyline
  headerContainerKLYellow: {
    // flex:1,
    padding: 20,
    backgroundColor: Colors.WHITE,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    // borderBottomLeftRadius: 80,
    // flex: 1,
    // flexDirection: "row",
    // borderBottomColor: "#dddddd",
    // borderBottomWidth: 1,
    // borderLeftColor: "#dddddd",
    // borderLeftWidth: 1,
  },
  headerTextYellow: {
    // flex: 1,
    // justifyContent:"flex-start",
    // paddingLeft: 90,
    // alignSelf: "center",
    // justifyContent:"center",
  },
  // header with keyline
  headerContainerKLWide: {
    height: 88,
    backgroundColor: "#FFC72C",
    borderBottomLeftRadius: 80,
    borderBottomColor: "#dddddd",
    borderBottomWidth: 1,
    borderLeftColor: "#dddddd",
    borderLeftWidth: 1,
  },
  // header for charity detial page
  // not used?
  headerContainerCharity: {
    flexDirection: "row",
    height: 88,
    paddingRight: 20,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 50,
    borderBottomColor: "#dddddd",
    borderBottomWidth: 1,
    borderLeftColor: "#dddddd",
    borderLeftWidth: 1,
  },
  // make for text and logo layout horizontal
  headerTextBoxTwo: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  // make for text and logo layout horizontal
  headerTextBoxTwoDonate: {
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  // make header text stack
  headerTextCol: {
    flexDirection: "column",
  },
  // make header text stack
  headerTextColApp: {
    flex: 1,
    flexDirection: "column",
    paddingLeft: 50,
  },
  // header text styles
  headerText: {
    position: "absolute",
    top: 0,
    //left: 50,
    paddingLeft: 50,
  },
  // header text styles
  // headerTextYellow: {
  //   position: "absolute",
  //   top: 0,
  //   left: 150,
  // },
  headerTextP: {
    position: "absolute",
    top: 0,
    left: 0,
    paddingLeft: 50,
    paddingRight: 10,
  },
  headingStyle: {
    fontFamily: "montserrat-bold",
    //  fontFamily: "montserrat-light",
    fontSize: 20,
    // fontSize: 16,
    textAlign: "left",
    marginBottom: 5,
    color: "#333333",
  },
  headingStyleForLongText: {
    fontFamily: "montserrat-bold",
    fontSize: 13,
    textAlign: "left",
    marginBottom: 5,
    color: "#333333",
  },
  headingStyleWeb: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "left",
    marginBottom: 5,
  },
  headingStyleApp: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "left",
    marginBottom: 5,
    marginLeft: 20,
  },
  headingStylePercent: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "left",
    marginBottom: 5,
    //maxWidth: "75%",
    minWidth: 200,
    maxWidth: 200,
  },
  subheaderStyle: {
    fontFamily: "montserrat-italic",
    fontSize: 12,
    //color: "#30829E",
    color: "#776c7e",
    textAlign: "left",
    marginBottom: 5,
    paddingRight: 10,
  },
  subheaderStyleWeb: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    color: Colors.DARKGRAY,
    textAlign: "left",
    marginBottom: 5,
    paddingRight: 10,
  },
  subheaderStyleDonate: {
    fontFamily: "montserrat-italic",
    fontSize: 12,
    //color: "#30829E",
    color: "#776c7e",
    textAlign: "left",
    marginBottom: 5,
    minWidth: 200,
    maxWidth: 200,
  },
  subheaderStyleApp: {
    fontFamily: "montserrat-italic",
    fontSize: 12,
    color: "#776c7e",
    textAlign: "left",
    marginBottom: 5,
    marginLeft: 20,
  },
  // centered link style footer of content
  centerContent: {
    //// flex: 1,
  },
  linkStyle: {
    paddingTop: 30,
    //paddingBottom: 10,
    //borderBottomWidth: 2,
    //borderColor: "#FFC72C",
    //: 200,
    alignSelf: "center",
  },
  linkStyleTight: {
    //paddingTop: 30,
    //paddingBottom: 10,
    //borderBottomWidth: 2,
    //borderColor: "#FFC72C",
    //: 200,
    alignSelf: "center",
  },
  linkStyleWBar: {
    paddingTop: 30,
    alignSelf: "center",
  },
  // LinkBar: {
  //   width: 70,
  //   height: 4,
  //   backgroundColor: "#FFC72C",
  //   alignSelf: "center",
  //   marginTop: 10,
  //   marginBottom: 10,
  // }, this would be removed when we make sure,
  linkStyleXX: {
    borderBottomWidth: 2,
    borderColor: "#FFC72C",
  },
  TextStyleLink: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  TextStyleLinkW: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  // full screen image background styles
  backgroundContainer: {
    flex: 1,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: Colors.MIDBLUE,
  },
  backgroundImage: {
    flex: 1,
    width: null,
    height: null,
  },
  fullHeaderBarY: {
    //flex: 1,
    // borderBottomLeftRadius: 80,
    backgroundColor: Colors.WHITE,
    maxHeight: 220,
    height: 220,
  },
  fullHeaderBarW: {
    //borderBottomLeftRadius: 80,
    //backgroundColor: "#ffffff",
  },
  webBodyContainer: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 200,
    paddingRight: 150,
    paddingBottom: 30,
    // backgroundColor:"red"
  },
  shellMobileHeaderContainer: {
    flexDirection: "row",
    height: 150,
    backgroundColor: "#4ebdef",
    borderBottomLeftRadius: 50,
    borderBottomColor: "#4ebdef",
    borderBottomWidth: 1,
    borderLeftColor: "#4ebdef",
    borderLeftWidth: 1,
  },
  headerBodyTextStyleInvetment: {
    color: "black",
    textAlign: "left",
    fontFamily: "montserrat-semibold",
    fontSize: 14,
    width: "100%",
    paddingBottom: 15,
    //paddingLeft: 10,
    //paddingRight: 30,
  },
  bodyTextStyleInvetment: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    paddingBottom: 5,
    paddingTop: 5,
    lineHeight: 18
  },
  textButtonStyleInvestment: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },
  formInputBoxInvest: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#FFFF",
    marginTop: 10,
    justifyContent: "center",
    borderWidth: 1,
    width: "100%",
    borderRadius: 5,
    borderColor: "#C6C6C6",
    height: 48
  },
  formInputContainerInvest: {
    flexDirection: "column",
    width: "100%",
    marginTop: 20,
  },
  formLabelTextInvest: {
    fontFamily: "montserrat-medium",
    fontSize: 12,
    color: "#333333",
  },
  formErrorTextInvest: {
    fontFamily: "montserrat-medium",
    fontSize: 10,
    color: Colors.MIDGRAY,
    textAlign: "center",
  },
  textInputInvest: {
  },
  radioButtonInvest: {
    color: "#333333"
  },
  buttonContainerInvest: {
    flexDirection: "row",
    marginTop: 35,
    marginBottom: 30,
    justifyContent: "space-evenly",
  },
  submitBackButtonStyleInvestment: {
    borderRadius: 50,
    borderColor: "#ffffff",
    borderWidth: 1,
    height: 50,
    justifyContent: 'center',
    height: 52,
    width: 120,
    //marginLeft: 35
  },
  submitContinueButtonStyleInvestment: {
    borderRadius: 50,
    backgroundColor: Colors.YELLOW,
    height: 50,
    justifyContent: 'center',
    height: 52,
    width: 120,
    //marginRight: 35
  },
  textButtonStyleInvest: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },
  headerTitleBackArrowWebContainer: {
    backgroundColor: Colors.WHITE,
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  toggleContainerForWeb: {
    backgroundColor: Colors.MIDBLUE,
    width: 140,
    borderRadius: 50,
  },
  backIconContainerForWeb: {
    marginLeft: -30
  },
  headerTextYellowForweb: {
    flexDirection: "row"
  },
  topHeaderTitelContainerForWeb: {
    alignItems: "flex-start",
    alignSelf: "center",
    width: "100%",
    maxWidth: 1090 > win.width ? 450 : 1200,
  },
  twoThirdContainerForWeb: {
    // flex: 2,
    justifyContent: "flex-start",
    paddingLeft: 25,
    width: 800,
    backgroundColor: "blue"
  },
  oneThirdContainerForWeb: {
    // flex: 1,
    justifyContent: "flex-start",
    paddingRight: adjustablepaddingRight,
    width: 400,
    backgroundColor: "yellow"
  },
  twoColumnViewContainerForWeb: {
    // flexDirection: "row",
    // // marginLeft: adjustableLeftMargin,
    // // marginRight: adjustableRightMargin,
    // paddingTop: 30,
    // paddingBottom: 30,
    // maxWidth: adjustableMaxWidth,
    // alignSelf: adjustableAlignSelf,
    // width: "100%",
    alignSelf: "center",
    backgroundColor: "red",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
  },
  twoColumnbodyContainerFullForWeb: {
    flexDirection: "column",
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 25,
    paddingRight: 25,
  },
  investTopContainer: {
    alignItems: "flex-start",
    alignSelf: "center",
    width: "100%",
    maxWidth: 1090 > win.width ? 450 : 1200,
  },
  investHeaderText: {
    flexDirection: "row",
  },
  investIconContainer: {
    marginLeft: -150
  },
  investScrollView: {
    flex: 1,
    backgroundColor: Colors.WHITE,
  },
  investTwoColumnMobileBodyContainer: {
    flexDirection: "column",
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 25,
    paddingRight: 25,
  },
  investModalMainContainer: {
    marginTop: 190,
    paddingRight: 30,
    paddingLeft: 30,
    paddingBottom: 30,
    alignItems: "center",
  },
  investModalContainer: {
    height: 160,
    backgroundColor: Colors.WHITE,
    borderRadius: 10,
    paddingTop: 30,
    paddingBottom: 30,
    paddingRight: 10,
    paddingLeft: 10,
    width: "100%",
  },
  bodyNormalTextStyle: {
    color: Colors.MIDGRAY,
    textAlign: "left",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 16,
  },
  investUnderline: {
    width: "80%",
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "center",
    marginTop: 5,
    marginBottom: 5,
  },
  SD_Body_Container: {
    flex: 1,
    alignSelf: "center",
    maxWidth: 1200,
    width: "100%",
  },
  SD_Flex_Container: {
    flexWrap: "wrap",
    flexDirection: "row",
  },
  SD_Full_Width_Container: {
    flex: 1,
  },
  SD_ColA: {
    flex: 1,
    minWidth: 350,
  },
  SD_ColB: {
    flex: 2,
    minWidth: 350,
  },
});

export default GlobalStyles;
